import NewBranchDialog from './Container'
export default NewBranchDialog


// WEBPACK FOOTER //
// ./src/pages/RepositoryEdit/NewBranchDialog/index.js